export default "__VITE_ASSET__Ccxjh74I__"